module.exports = __webpack_public_path__ + "static/media/portfolio-1.3a3343e0.webp";